import {
  BackgroundTask,
  BackgroundTasksService,
  BaseTaskPayload,
  FindTasksParams,
  PaginatedTasksResponse,
  ReleaseBackgroundTaskBody,
} from '@services/backgroundTaskService'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const getBackgroundTasks = createAsyncThunk<
  PaginatedTasksResponse,
  FindTasksParams
>('background-tasks/all', async (params) => {
  return await BackgroundTasksService.getBackgroundTasks(params)
})

export const doReleaseHeldBackgroundTasks = createAsyncThunk<
  BackgroundTask,
  { uid: string; body: BaseTaskPayload }
>('background-tasks/release', async ({ uid, body }) => {
  console.log('body : ', body)
  return await BackgroundTasksService.releaseBackgroundTask(uid, body)
})

export const cancelBackgroundTask = createAsyncThunk<BackgroundTask, string>(
  'background-tasks/cancel',
  async (uid) => {
    return await BackgroundTasksService.cancelTask(uid)
  },
)
